<template>
    <div v-if="!isValid">
        <div class="col-12 mt-3 mb-3">
            <div class="form-group">
                <label for="password">{{ message }}</label>
                <input type="password" id="password" placeholder="Contraseña" v-model="current_password"/>
                <div v-if="validation_message" class="alert alert-danger mt-2 p-1"><strong>{{ validation_message }}</strong></div>
            </div>
            <Button @click="submit" name="button">CONTINUAR</Button>
        </div>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['message'],
        data() {
            return {
                current_password: '',
                correct_password: 'FBxqeA81fUxOmL',
                isValid: false,
                validation_message: ''
            }
        },
        methods: {
            submit() {
                if (this.current_password == this.correct_password) {
                    this.isValid = true;
                } else if (this.current_password == '') {
                    this.validation_message = 'La contraseña es obligatoria';
                } else {
                    this.validation_message = 'La contraseña es incorrecta';
                }
            }
        },
        watch: {
            current_password() {
                if (this.current_password === this.correct_password) {
                    this.validation_message = '';
                }
            }
        }
    }
</script>